import axios from 'axios';
import config from '../Config'; // Path to your config file
import authHeader from './auth-header'; // Path to your auth header


const API_URL = config.API_URL; // Base API URL
const API_VERSION = config.API_VERSION; // API version
const addSeller = (formData) => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/seller/`,
    formData, // Payload for the request body
    { headers: authHeader() } // Authentication header
  );
};
const getSellerList = (page, pagesize, search, ordering) => {
  return axios.get(`${API_URL}/api/${API_VERSION}/first_weight_entry/sellers/`, {
    headers: authHeader(),
    params: {
      deleted: 0,
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering
    } // Parameters for pagination and search
  });
};

const getSellerDropdown = (page, pagesize, search, ordering) => {
  return axios.get(`${API_URL}/api/${API_VERSION}/seller/`, {
    headers: authHeader(),
    params: {
      fields: 'id, name, deleted',
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering
    } // Parameters for pagination and search
  });
};

const getSellerArchiveList = (page, pagesize, search, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/seller-archive', {
    headers: authHeader(), params: {
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering
    }
  });
};
const updateSeller = (id, formPayload) => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/seller/${id}/`, // Include the die group's ID in the URL
    formPayload, // Payload for the request body
    { headers: authHeader() } // Authentication header
  );
};
const deleteSeller = (id) => {
   
  return axios.delete(
      `${API_URL}/api/${API_VERSION}/seller/${id}/`,
      { headers: authHeader() }, // Authentication header
    );
};
const unArchiveSeller = (id) => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/seller/${id}/unarchive/`, // Include the die group's ID in the URL
    {}, // Pass an empty object if no data needs to be sent
    { headers: authHeader() } // Authentication header
  );
};
const sellerService = {
  addSeller,
  getSellerList,
  getSellerArchiveList,
  updateSeller,
  deleteSeller,
  unArchiveSeller,
  getSellerDropdown
};

export default sellerService;
